import blogCoverImage from "../assets/blog-cover.png";
import galanterijaImage from "../assets/galanterija.png";
import servisImage from "../assets/servis.png";
import sovetiImage from "../assets/soveti.png";
import telefoniImage from "../assets/telefoni.png";

const normalizeCategory = (value = "") => value.toLowerCase().trim();

const categoryImages = {
  "галантерија": galanterijaImage,
  "полнење": galanterijaImage,
  "сервис": servisImage,
  "совети": sovetiImage,
  "локален водич": sovetiImage,
  "купување телефон": telefoniImage,
  "телефони": telefoniImage,
  iphone: telefoniImage,
  samsung: telefoniImage,
  xiaomi: telefoniImage,
  huawei: telefoniImage,
};

export const getBlogImage = (post) =>
  post.heroImage || categoryImages[normalizeCategory(post.category)] || blogCoverImage;

export const getBlogImageAlt = (post) =>
  post.heroAlt || `${post.title} - Buzz Mobile`;
